<template>
    <div class="nebiki-container">
        <div v-if="step == 'petit_tanaoroshi'" class="petit-tanaoroshi">
            <div>
                <div class="buttons-wrap">
                    <span class="btn-lg btn-primary" @click="startNebikiCalculation()">ラベル発行開始</span>
                </div>
                <b-form-group v-if="!lastScannedBarcode">
                    <div id="item-info-wrap-wrap">
                        <span id="barcode-scan-message">バーコードをスキャンしてください</span>
                    </div>
                </b-form-group>

                <b-form-group v-if="lastScannedBarcode">
                    <div id="item-info-wrap-wrap">
                        <div class="item-info-wrap">
                            <div class="item-code">
                                <span>{{lastScannedBarcode}}</span>
                            </div>
                            <div class="item-name">
                                <span>{{items.find(i => i.item_cd == lastScannedBarcode).item_name}}</span>
                            </div>
                        </div>
                        <div>
                            <input class="suryo-input" type="number" size="3" disabled :value="(lastRegisteredZaikoInfo || {}).suryo">
                        </div>
                    </div>
                </b-form-group>

                <b-form-group id="suryo-form">
                    <keypad
                        class="suryo-keypad"
                        ref="keypad"
                        v-on:change="petitTanaoroshiValueChanged($event)"
                    />
                </b-form-group>
            </div>
        </div>

        <div v-if="step == 'label_printing'" class="label-printihg">
            <div id="nevigation-buttons-wrap">
                <div>
                    <div class="left">
                        <span class="btn-lg btn-primary" @click="backToPetitTanaoroshi()">棚卸に戻る</span>
                    </div>
                </div>
                <div>
                    <div class="right">
                        <span class="btn-lg btn-danger" @click="confirmGotoNextGroup()">次のグループへ進む</span>
                    </div>
                </div>
            </div>

            <div class="alert-wrap">
                <div v-for="alert in activeAlerts" v-bind:key="alert.id">
                    <tanpin-nebiki
                        v-bind:class="alert.state"
                        v-bind:alert="alert"
                    />
                </div>
            </div>

            <!-- 自動, 手動の切り替え -->
            <div id="config-panel" class="config-panel">
                <b-form-group>
                    <b-form-radio-group
                        v-model="printMode"
                        :options="printModeOptions"
                        class="mb-3"
                        buttons
                    />
                </b-form-group>
            </div>

            <tanpin-nebiki-print-modal ref="tanpin-nebiki-print-modal" @publish="printNebikiLabel($event.item_cd, $event.count)" />
        </div>

        <alert-dialog ref="alert-dialog" />
        <confirm-dialog ref="confirm-back-to-tanaoroshi-dialog" @choosed="gotoNextGroup($event)" />
    </div>
</template>

<style>
#config-panel .btn {
    height: 72px;
    padding-top: 20px;
    border: none;
    font-weight: 700;
    background: #e7e6e6;
    color: #afabab;
}

#config-panel .btn.active {
    background: #c1eded;
    color: #46c9cb;
}

#config-panel {
    height: 90px;
    padding: .5rem;
    border-width: .2rem;
}

#config-panel fieldset,
#config-panel .btn-group {
    margin-bottom: 0 !important;
}

#config-panel .btn-group {
    width: 100%;
}

.buttons-wrap {
    height: 3em;
    text-align: right;
}

.opacity0 {
    opacity: 0;
}

.nebiki-container {
    height: 100%;
}

#suryo-form > div {
    display: grid;
}

#suryo-form > div > * {
    margin: 0 5px;
}

#zaiko-list {
    height: calc(100% - 585px);
    overflow: scroll;
}

.tanaoroshi-table .suryo {
    text-align: right;
}

.keypad-row {
    padding: 10px 5px;
    text-align: center;
}

.keypad-row span {
    margin: 0 15px;
}

.keypad-row .btn-lg {
    padding: .7rem 3rem;
    font-size: 4rem;
    line-height: 1.7;
    border-radius: .3rem;
}

#item-info-wrap-wrap {
    height: 100px;
    display: grid;
    grid-template-columns: 1fr 150px;
}

#barcode-scan-message {
    font-size: 1.4em;
}

.item-info-wrap .item-name {
    font-size: 2em;
}

.item-info-wrap .item-code {
    font-size: 1.5em;
}

.suryo-wrap {
    text-align: right;
}

.suryo-input {
    text-align: right;
    width: 140px;
    font-size: 2.5em;
}

#nevigation-buttons-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

#nevigation-buttons-wrap .left {
    text-align: left;
}

#nevigation-buttons-wrap .right {
    text-align: right;
}

.petit-tanaoroshi,
.label-printihg {
    height: 100%;
}

.petit-tanaoroshi .form-group {
    margin-bottom: .2rem;
}

.alert-wrap {
    height: calc(100% - 210px);
    overflow: scroll;
}
</style>

<script>
import router from '@/router'
import { BarcodePattern } from '@/utils/barcode.js'
import TanpinNebiki from '@/components/views/alert/TanpinNebiki.vue'
import TanpinNebikiPrintModal from '@/components/views/alert/TanpinNebikiPrintModal.vue'
import Keypad from '@/components/views/Keypad.vue'
import AlertDialog from '@/components/views/AlertDialog.vue'
import ConfirmDialog from '@/components/views/ConfirmDialog.vue'
import fleqvLabels from '@/utils/fleqv_label.js'

function calcModulus10(text) {
    const [v1, v2] = text.split("").reverse().reduce((prev, curr, idx) => {
        const idxMod2 = (idx + 1) % 2
        prev[idxMod2] += curr * (idxMod2 ? 3 : 1)

        return prev
    }, [0, 0])

    return (10 - (v1 + v2) % 10) % 10
}

function calcPriceCheckDigit(price) {
    const price_text = ("0000" + price).slice(-4)
    const P1 = +price_text[0]
    const P2 = +price_text[1]
    const P3 = +price_text[2]
    const P4 = +price_text[3]

    const step1_v1 = (P1 * 2) % 10
    const step1_v2 = (P2 * 2) % 10
    const step1_v3 = P3 * 3
    const step1_v4 = (P4 * 5) % 10

    const step2_value = step1_v1 + step1_v2 + step1_v3 + step1_v4
    const step3_value = step2_value * 3

    return step3_value % 10
}

export default {
    name: 'Nebiki',
    components: {
        TanpinNebiki,
        TanpinNebikiPrintModal,
        Keypad,
        AlertDialog,
        ConfirmDialog,
    },

    data() {
        return {
            name: "nebiki",
            acceptKeyInput: true,
            barcodeInputBuffer: "",

            // petit_tanaoroshi -> label_printing
            step: "petit_tanaoroshi",
            groups: [],
            items: [],

            lastScannedBarcode: null,

            petitTanaoroshi: [], // [ { item_cd = <item_cd>, suryo: <在庫数> }, ...]

            printMode: "auto", // "auto" or "manual"
            printModeOptions: [
                { text: "自動発行", value: "auto", },
                { text: "手動発行", value: "manual", },
            ]
        }
    },

    computed: {
        lastRegisteredZaikoInfo() {
            return this.petitTanaoroshi.find(pt => pt.item_cd == this.lastScannedBarcode)
        },

        petitTanaoroshiHistory() {
            return [...this.petitTanaoroshi].reverse().map(pt => {
                return {
                    item_cd: pt.item_cd,
                    item_name: this.items.find(i => i.item_cd == pt.item_cd).item_name,
                    suryo: pt.suryo
                }
            })
        },

        activeAlerts() {
            return this.$store.state.alerts.alerts
                .map(a => Object.assign({}, a))
                .filter(a => a.state == "active")
                .map(alert => {
                    const printing = this.$store.state.printer.queue.filter(e => e.item_cd == alert.item_cd)

                    if (printing.length) {
                        alert.state = "printing"
                    }

                    return alert
                })
        },
    },

    async mounted() {
        this.signOut()

        const state = this.$store.state
        const companyCd = state.setting.companyCd
        const storeCd = state.setting.storeCd

        this.barcodePattern = new BarcodePattern(state.setting)

        if (!state.setting.companyCd || !state.setting.storeCd) {
            router.push({
                path: '/setting'
            })
            return
        }

        document.addEventListener("keydown", this.handleKeyDown);
        window.addEventListener("beforeunload", this.confirmUnload);

        try {
            this.startLoading()
            const result = await this.getData2('fleqv', `/company/${companyCd}/store/${storeCd}/delica_nebiki_items`)
            console.log(result)
            this.items = result
        } finally {
            this.stopLoading()
        }
    },

    destroyed() {
        document.removeEventListener("keydown", this.handleKeyDown);
        window.removeEventListener("beforeunload", this.confirmUnload);
    },

    methods: {
        confirmUnload(event) {
            event.preventDefault()
            event.returnValue = ''

            return ''
        },

        isModalViewing() {
            return [
                'tanpin-nebiki-print-modal',
                'alert-dialog',
                'confirm-back-to-tanaoroshi-dialog',
            ].some((refName) => this.$refs[refName]?.isOpen())
        },

        showAlert(message) {
            this.$refs["alert-dialog"].open(message)
        },

        reset() {
            this.lastScannedBarcode = null
            this.petitTanaoroshi = []

            // アラートを削除
            this.$store.commit('alerts/applyAlerts', [])
        },

        backToPetitTanaoroshi() {
            this.step = "petit_tanaoroshi"
        },

        confirmGotoNextGroup() {
            this.$refs["confirm-back-to-tanaoroshi-dialog"].open("棚卸在庫をクリアしますがよろしいですか？")
        },

        gotoNextGroup({ ok }) {
            if (!ok) {
                return
            }

            this.reset()
            this.backToPetitTanaoroshi()
        },

        async handleKeyDown(event) {
            console.log(event)

            if (this.isModalViewing()) {
                return
            }

            if (!this.acceptKeyInput) {
                return
            }

            // テキストボックスではキーボード入力を横取りしない
            if (event.target.tagName == "INPUT" && ["text", "number"].includes(event.target.type)) {
                return
            }

            event.preventDefault()
            event.stopPropagation()

            if (event.key == "Enter") {
                const barcode = this.barcodeInputBuffer
                this.barcodeInputBuffer = ""

                this.acceptKeyInput = false
                await this.handleBarcodeScan(barcode)
                this.acceptKeyInput = true

                return
            }

            if (!"0123456789".includes(event.key)) {
                return
            }

            this.barcodeInputBuffer += event.key
        },

        async handleBarcodeScan(barcode) {
            const barcodeInfo = this.barcodePattern.parse(barcode)

            if (!barcodeInfo) {
                this.showAlert(`不明なバーコード形式(${barcode})`)
                return
            }

            // 商品マスタの商品コード
            const jan_cd = barcodeInfo.is_futeikan ? barcodeInfo.generic_item_code : barcodeInfo.item_code

            if (this.step == "petit_tanaoroshi") {
                const item = this.items.find(i => i.item_cd == jan_cd)

                // グループ外の商品をスキャンした場合
                if (!item) {
                    this.showAlert("商品情報が存在しません")
                    return
                }

                let pt = this.petitTanaoroshi.find(pt => pt.item_cd == jan_cd)

                if (!pt) {
                    pt = { item_cd: jan_cd, suryo: 0 }
                    this.petitTanaoroshi.push(pt)
                }

                this.lastScannedBarcode = jan_cd

                let pt2 = this.petitTanaoroshi.find(pt => pt.item_cd == jan_cd)

                // スキャンされた商品の在庫数を+1する
                if (pt2.suryo != null) {
                    pt2.suryo++
                }

                this.$refs.keypad.reset(pt2.suryo)
            }
            else if (this.step == "label_printing") {
                // アラートをとってくる
                const alert = this.activeAlerts.find(a => a.item_cd == jan_cd)

                const itemInfo = this.items.find(i => i.item_cd == jan_cd)
                const zaikoInfo = this.petitTanaoroshi.find(pt => pt.item_cd == jan_cd)

                const base_nebiki_rate = this.groups.find(g => g.group_cd == alert?.group_cd)?.nebiki_rate
                const nebiki_rate = alert?.nebiki_rate || base_nebiki_rate

                if (!nebiki_rate) {
                    this.showAlert(`この商品の値引は不要です`)
                    return
                }

                if (this.printMode == "manual") {
                    // 手動発行
                    this.openNebikiPrintModal({
                        item_cd: barcodeInfo.item_code,
                        item_name: itemInfo.item_name,
                        count: zaikoInfo.suryo,  // 定貫/不定貫に関わらず在庫数分
                    })
                }
                else {
                    // 自動発行
                    this.printNebikiLabel(
                        barcodeInfo.item_code,
                        alert.individual_flag ? 1 : zaikoInfo.suryo  // 定貫なら在庫数分、不定貫なら1枚
                    )
                }
            }
            else {
                // do nothing
            }
        },

        petitTanaoroshiValueChanged(event) {
            if (this.lastRegisteredZaikoInfo) {
                const suryo = event.value
                this.lastRegisteredZaikoInfo.suryo = suryo

                if (("" + suryo).length == 3) {
                    this.showAlert("100以上の数値が入力されましたがよろしいですか？")
                }
            }
        },

        async startNebikiCalculation() {
            const state = this.$store.state
            const companyCd = state.setting.companyCd
            const storeCd = state.setting.storeCd

            try {
                this.startLoading()
                const result = await this.postData2('fleqv', `/company/${companyCd}/store/${storeCd}/calculate_alert`, {
                    items: this.petitTanaoroshi
                        .filter(pt => !!pt.suryo)
                        .map(pt => {
                            return {
                                item_cd: pt.item_cd,
                                zaiko_su: pt.suryo,
                            }
                        })
                })
                console.log(result)
                this.step = "label_printing"

                // アラートを登録
                this.$store.commit('alerts/applyAlerts', result.alerts.map((alert) => ({
                    ...alert,
                    id: alert.item_cd,
                    state: "active",
                })))

                this.groups = result.groups
            } finally {
                this.stopLoading()
            }
        },

        async printNebikiLabel(item_code, count) {
            const state = this.$store.state
            const isSato = ["SATO", "SATO_DEMO"].includes(state.setting.companyCd)

            const barcodeInfo = this.barcodePattern.parse(item_code)
            const item_master_item_code = barcodeInfo.is_futeikan ? barcodeInfo.generic_item_code : item_code
            const alert = this.activeAlerts.find(a => a.item_cd == item_master_item_code)

            const itemInfo = this.items.find(i => i.item_cd == item_master_item_code)

            const base_nebiki_rate = this.groups.find(g => g.group_cd == alert.group_cd)?.nebiki_rate
            const nebiki_rate = alert.nebiki_rate || base_nebiki_rate
            const nebiki_percentage = Math.floor(nebiki_rate * 100)
            const price_checkdigit = calcPriceCheckDigit(nebiki_percentage)
            const base_barcode = `922${price_checkdigit}${("000000" + nebiki_percentage).slice(-6)}${barcodeInfo.item_code}`
            const std_price = alert.individual_flag ? barcodeInfo.price : alert.std_price

            const smts_base_barcode = `${barcodeInfo.item_code}3${("00000"+std_price).slice(-5)}`

            const labelParams = {
                "バーコード": (isSato ? smts_base_barcode : base_barcode) + calcModulus10(base_barcode),
                "値引額": nebiki_percentage,
                "担当者コード": "0000000",
                "商品名": itemInfo.item_name,
                "(発行枚数)": count,
            }

            if (isSato) {
                labelParams["元売価"] = std_price
            }

            if (alert.individual_flag) {
                labelParams["新価格"] = Math.floor(barcodeInfo.price * (1 - nebiki_rate))
            }
            else {
                labelParams["新価格"] = Math.floor(alert.std_price * (1 - nebiki_rate))
            }

            return await this.sendPrintRequest(labelParams)
        },

        async sendPrintRequest(labelParams) {
            const state = this.$store.state
            const isSato = ["SATO", "SATO_DEMO"].includes(state.setting.companyCd)

            const isHalfPrice = labelParams["値引額"] == 50 // 半額なら別のレイアウトを使うようにする
            const formatIdKey = isHalfPrice ? "halfPriceFormatId" : "formatId"

            const label = isSato ? fleqvLabels.forSmts2 : fleqvLabels.ankDemo

            try {
                return await this.$store.dispatch(
                    "printer/printTanpinNebiki",
                    {
                        printerURL: this.$store.state.setting.printerURL,
                        layoutFileBase64: label,
                        formatId: this.$store.state.setting[formatIdKey],
                        printParams: labelParams,
                    }
                )                
            } catch (error) {
                this.showAlert(error)
            }
        },

        openNebikiPrintModal(item_info) {
            this.$refs['tanpin-nebiki-print-modal'].open(item_info)
        },
    },
}
</script>
